module.exports = __webpack_public_path__ + "img/achievements.314b1a89.jpg";